/*
 * Company actions
 */

/** Get list of companies action constants */
export const GET_COMPANIES = 'DFIM_GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'DFIM_GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_ERROR = 'DFIM_GET_COMPANIES_ERROR';

/**
 * This starts when the user is logged in
 * @return {object}       An action object with a type of GET_COMPANIES.
 *
 * */
export const getAllCompanies = (user) => ({ type: GET_COMPANIES, payload: user });
/**
 * Dispatched when the companies are loaded.
 * @param {object}       the companies loaded from the backend.
 * @return {object}       An action object with a type of GET_COMPANIES_SUCCESS passing the companies.
 *
 * */
export const getAllCompaniesSuccess = (data) => ({ type: GET_COMPANIES_SUCCESS, payload: data });
/**
 * Dispatched when the companies failed to load
 * @param  {object} error The error
 * @return {object}       An action object with a type of GET_COMPANIES_ERROR passing the error
 *
 * */
export const getAllCompaniesError = (error) => ({ type: GET_COMPANIES_ERROR, error: error });

/** Create company action constants */
export const COMPANY_CREATE = 'DFIM_COMPANY_CREATE';
export const COMPANY_CREATE_SUCCESS = 'DFIM_COMPANY_CREATE_SUCCESS';
export const COMPANY_CREATE_ERROR = 'DFIM_COMPANY_CREATE_ERROR';

/**
 * This starts the company epic
 * @return {object}       An action object with a type of COMPANY_CREATE.
 *
 * */
export const companyCreate = (company) => ({ type: COMPANY_CREATE, payload: company });
/**
 * Dispatched when the company is created
 * @param {object}       the company created
 * @return {object}       An action object with a type of COMPANY_CREATE_SUCCESS passing the company.
 *
 * */
export const companyCreateSuccess = (data) => ({ type: COMPANY_CREATE_SUCCESS, payload: data });
/**
 * Dispatched when the company is not created
 * @param  {object} error The error
 * @return {object}       An action object with a type of COMPANY_CREATE_ERROR passing the error
 *
 * */
export const companyCreateError = (error) => ({ type: COMPANY_CREATE_ERROR, error: error });

/** Edit company action constants */
export const COMPANY_EDIT = 'DFIM_COMPANY_EDIT';
export const COMPANY_EDIT_SUCCESS = 'DFIM_COMPANY_EDIT_SUCCESS';
export const COMPANY_EDIT_ERROR = 'DFIM_COMPANY_EDIT_ERROR';

/**
 * This starts the company epic
 * @return {object}       An action object with a type of COMPANY_EDIT.
 *
 * */
export const companyEdit = (company) => ({ type: COMPANY_EDIT, payload: company });
/**
 * Dispatched when the company is edited
 * @param {object}       the company edited
 * @return {object}       An action object with a type of COMPANY_EDIT_SUCCESS passing the company.
 *
 * */
export const companyEditSuccess = (data) => ({ type: COMPANY_EDIT_SUCCESS, payload: data });
/**
 * Dispatched when the company is not edited
 * @param  {object} error The error
 * @return {object}       An action object with a type of COMPANY_EDIT_ERROR passing the error
 *
 * */
export const companyEditError = (error) => ({ type: COMPANY_EDIT_ERROR, error: error });

/** Delete company action constants */
export const COMPANY_DELETE = 'DFIM_COMPANY_DELETE';
export const COMPANY_DELETE_SUCCESS = 'DFIM_COMPANY_DELETE_SUCCESS';
export const COMPANY_DELETE_ERROR = 'DFIM_COMPANY_DELETE_ERROR';

/**
 * This starts the company epic
 * @return {object}       An action object with a type of COMPANY_DELETE.
 *
 * */
export const companyDelete = (id) => ({ type: COMPANY_DELETE, payload: id });
/**
 * Dispatched when the company is deleted
 * @param {object}       the company deleted
 * @return {object}       An action object with a type of COMPANY_DELETE_SUCCESS passing the company.
 *
 * */
export const companyDeleteSuccess = (data) => ({ type: COMPANY_DELETE_SUCCESS, payload: data });
/**
 * Dispatched when the company is not deleted
 * @param  {object} error The error
 * @return {object}       An action object with a type of COMPANY_DELETE_ERROR passing the error
 *
 * */
export const companyDeleteError = (error) => ({ type: COMPANY_DELETE_ERROR, error: error });
